import { Tooltip } from 'antd'

type Props = {
  equation: string
  values: string
  customizedValue?: string
  customizedLabel?: string
}

const CalculationTooltip = ({ equation, values, customizedValue, customizedLabel = 'Customized to', children }: React.PropsWithChildren<Props>) => {
  const title = <div style={{ whiteSpace: 'nowrap' }}>
    <div>{equation}</div>
    <div style={customizedValue ? { textDecoration: 'line-through' } : undefined}>{values}</div>
    {customizedValue && <div>{customizedLabel} {customizedValue}</div>}
  </div>

  return <Tooltip title={title}><span>{children}</span></Tooltip>
}

export default CalculationTooltip
